import { MechanicInstallation, Pagination, LatLngBounds, LatLng, MapOptions } from '@/types';
import { AsyncModule } from 'vuex-async-mutations';

type MapsState = {
  options: MapOptions;
  installations: MechanicInstallation[];
  searchTerm: string | null;
};

export const module: AsyncModule<MapsState, any> = {
  namespaced: true,

  async: true,

  state: {
    options: {
      zoom: 11,
      center: { lat: 52.092876, lng: 5.10448 },
    },
    installations: [],
    searchTerm: null,
  },

  mutations: {
    ['set:options'](state, options: MapOptions) {
      state.options = { ...state.options, ...options };
    },

    ['set:searchTerm'](state, searchTerm: string) {
      state.searchTerm = searchTerm;
    },
  },

  actionsAsync: {
    ['search']: {
      async handler({ commitAsync, state }, searchTerm: string) {
        return commitAsync(
          this.$axios.$get('/installations', {
            params: { searchTerm: searchTerm ?? undefined, perPage: 1000 },
          }),
          searchTerm,
        );
      },

      pending(state, searchTerm: string) {
        state.searchTerm = searchTerm;
      },

      resolved(state, installations: Pagination<MechanicInstallation>) {
        state.installations = installations.data;
      },
    },
  },
};

export default module;
